module.exports = "<viaticos-todos-lista\r\n    ng-if=\"!$ctrl.form.$dirty\"\r\n    busqueda=\"$ctrl.busqueda\"></viaticos-todos-lista>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/viaticos/components/todos/template.html
// module id = 3250
// module chunks = 0